import messages from './modules/messages'
import projects from './modules/projects'
import plugins from './modules/plugins'
import account from './modules/account'
import forms from './modules/forms'

export default {
  messages,
  projects,
  plugins,
  account,
  forms
}
